import React from 'react';
import cls from 'classnames';

// @ts-expect-error
import { DateTimeFieldWUT as DateTimeFieldForms } from '@wix/form-fields/dist/esm/ui/date-time-field/index';

import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';

import { Show } from '../Show';
import { Box } from '../Box';
import { Typography } from '../Typography';

import classes from './DateTimeField.scss';
import { getDateTimeFieldErrors } from './utils';
import { TPAComponentProps } from 'wui/types';

interface IProps extends TPAComponentProps {
  wired?: boolean;
  id: string;
  label?: string;
  required?: boolean;
  value: string;
  onChange(newValue: string): void;
  error?: string | undefined | false;
  onBlue?(e: any): void;
}

export function DateTimeField(props: IProps) {
  const { wired, id, label, required, value, error, ...rest } = props;

  const errors = getDateTimeFieldErrors(value);

  return (
    <Box direction="vertical" gap="8px">
      <Show if={!!label}>
        <Typography as="label" htmlFor={id} variant="p2-14">
          {label}
          <Show if={required}>
            <span> *</span>
          </Show>
        </Typography>
      </Show>

      <div
        className={cls(classes.root, {
          [classes.wired]: wired,
        })}
      >
        <DateTimeFieldForms
          inputId={id}
          ariaLabelledBy=""
          label={label}
          required={required}
          onFocus={() => {}}
          value={value}
          errors={errors || {}}
          {...rest}
        />
      </div>

      <Show if={!!error}>
        <Typography variant="p2-14" skin="error">
          {' '}
          <ErrorSmall aria-hidden /> {error}
        </Typography>
      </Show>
    </Box>
  );
}

DateTimeField.displayName = 'wui/DateTimeField';
